export const SORT_LABELS: string[] = ['Newest', 'Oldest', 'A-Z', 'Z-A'];
export const FAMILY_MEMBER_TABLE_HEAD: string[] = ['Employee code', 'Employee name', 'Email address', 'Family members name', 'Email of family members', 'Relationship', 'Request received on', 'Status', 'Action'];
export const TABS_LABEL: string[] = ['Requests received', 'View sent invites'];
